import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=2f1ab2f8"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"
import style0 from "./EmployeeList.vue?vue&type=style&index=0&id=2f1ab2f8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports